export type CodeResponse = { code: string | null }

export type AttributeRequest = { referralCode: string }

export type AttributeResponse =
  | { attributed: true }
  | { attributed: false; reason: RejectionReason }

export type StatsResponse =
  | { hasCode: false }
  | {
      hasCode: true
      code: string
      totalReferees: number
      activeReferees: number
      totalTxCount: number
      totalVolumeUsd: number
      totalFeesEarnedUsd: number
      referees: Array<{
        accountId: string
        joinedAt: string
        status: "active" | "inactive"
        volumeUsd: number
        feeUsd: number
        txCount: number
        lastActiveAt: string | null
      }>
    }

export type MyReferrerResponse = {
  referrer: { code: string; accountId: string } | null
}

export type RejectionReason =
  | "invalid_code"
  | "already_attributed"
  | "self_referral"
  | "not_claimable"
  | "invalid_request"
  | "internal_error"

// Reasons that won't change on retry — client stops re-POSTing once seen.
export const PERMANENT_REJECTION_REASONS = [
  "invalid_code",
  "already_attributed",
  "self_referral",
  "not_claimable",
] as const satisfies readonly RejectionReason[]

export type PermanentRejectionReason =
  (typeof PERMANENT_REJECTION_REASONS)[number]

export function isPermanentRejection(
  reason: RejectionReason
): reason is PermanentRejectionReason {
  return (PERMANENT_REJECTION_REASONS as readonly RejectionReason[]).includes(
    reason
  )
}
